<script setup lang="ts">
  const props = defineProps<{
    steps: { key: string; label: string }[]
    current: string
  }>()

  const currentIndex = computed(() =>
    Math.max(
      0,
      props.steps.findIndex(s => s.key === props.current)
    )
  )
</script>

<template>
  <div class="flex h-16 w-full items-stretch overflow-hidden bg-zinc-100">
    <div
      v-for="(s, i) in steps"
      :key="s.key"
      :class="[
        'arrow-right relative flex flex-1 items-center justify-center text-center font-special font-bold',
        i === 0 ? 'pl-6' : 'pl-12',
        i <= currentIndex ? 'bg-viking-400 text-white' : 'bg-zinc-200 text-zinc-500'
      ]"
    >
      {{ s.label }}
    </div>
  </div>
</template>

<style scoped>
  .arrow-right:not(:last-child)::after {
    content: '';
    position: absolute;
    right: -32px;
    top: 0;
    z-index: 1;
    width: 0;
    height: 0;
    border-top: 32px solid transparent;
    border-bottom: 32px solid transparent;
    border-left: 32px solid;
  }

  .arrow-right.bg-viking-400::after {
    border-left-color: #58d9db;
  }

  .arrow-right.bg-zinc-200::after {
    border-left-color: #e4e4e7;
  }
</style>
